var _defs, _style, _circle, _circle2, _circle3, _rect, _g, _circle4, _rect2, _rect3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtActivate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: "100%",
    height: "100%",
    role: "img",
    "aria-label": "Animated account activation illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Account activation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "avatarClip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 24
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .avatar {\n      transform-box: fill-box;\n      transform-origin: 50% 50%;\n      animation: arrive 5s cubic-bezier(0.34, 1.35, 0.45, 1) infinite;\n    }\n    @keyframes arrive {\n      0%, 4%    { transform: scale(0); opacity: 0; }\n      20%, 78%  { transform: scale(1); opacity: 1; }\n      90%, 100% { transform: scale(0); opacity: 0; }\n    }\n\n    .orbit {\n      fill: none; stroke: #19b87a; stroke-width: 3.5; stroke-linecap: round;\n      stroke-dasharray: 189;\n      animation: orbit 5s ease-in-out infinite;\n    }\n    @keyframes orbit {\n      0%, 20%   { stroke-dashoffset: 189; }\n      48%, 80%  { stroke-dashoffset: 0; }\n      90%, 100% { stroke-dashoffset: 189; }\n    }\n\n    .ln {\n      transform-box: fill-box;\n      animation: settle 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n    }\n    .ln-1 { animation-delay: 0.1s; }\n    .ln-2 { animation-delay: 0.24s; }\n    @keyframes settle {\n      0%, 26%   { transform: translateY(8px); opacity: 0; }\n      40%, 78%  { transform: translateY(0); opacity: 1; }\n      88%, 100% { transform: translateY(8px); opacity: 0; }\n    }\n\n    .badge {\n      transform-box: fill-box;\n      transform-origin: 50% 50%;\n      animation: pop 5s cubic-bezier(0.34, 1.45, 0.45, 1) infinite;\n    }\n    @keyframes pop {\n      0%, 56%   { transform: scale(0); opacity: 0; }\n      66%       { transform: scale(1.14); opacity: 1; }\n      72%, 82%  { transform: scale(1); opacity: 1; }\n      90%, 100% { transform: scale(0); opacity: 0; }\n    }\n\n    .tick {\n      stroke: #ffffff; stroke-width: 3.2; fill: none;\n      stroke-linecap: round; stroke-linejoin: round;\n      stroke-dasharray: 22;\n      animation: tick 5s ease-out infinite;\n    }\n    @keyframes tick {\n      0%, 62%   { stroke-dashoffset: 22; }\n      72%, 84%  { stroke-dashoffset: 0; }\n      88%, 100% { stroke-dashoffset: 22; }\n    }\n\n    .mote { animation: drift 6s ease-in-out infinite; }\n    .mote-2 { animation-duration: 7.5s; animation-delay: -2s; }\n    .mote-3 { animation-duration: 8.5s; animation-delay: -4s; }\n    @keyframes drift {\n      0%, 100% { transform: translateY(0); opacity: 0.55; }\n      50%      { transform: translateY(-7px); opacity: 1; }\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n      .avatar, .orbit, .ln, .badge, .tick, .mote { animation: none; }\n      .avatar { transform: scale(1); opacity: 1; }\n      .orbit { stroke-dashoffset: 0; }\n      .ln { transform: translateY(0); opacity: 1; }\n      .badge { transform: scale(1); opacity: 1; }\n      .tick { stroke-dashoffset: 0; }\n    }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "mote",
    cx: 22,
    cy: 58,
    r: 3.5,
    fill: "#ffffff",
    opacity: 0.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "mote mote-2",
    cx: 180,
    cy: 44,
    r: 4.5,
    fill: "#ffffff",
    opacity: 0.55
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "mote mote-3",
    cx: 26,
    cy: 170,
    r: 3,
    fill: "#ffffff",
    opacity: 0.55
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 38,
    width: 128,
    height: 124,
    rx: 18,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "avatar"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 24,
    fill: "#eaf3fb"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatarClip)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 73,
    r: 9,
    fill: "#2b8fe0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 88,
    width: 30,
    height: 26,
    rx: 15,
    fill: "#2b8fe0"
  })))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "orbit",
    cx: 100,
    cy: 80,
    r: 30,
    transform: "rotate(-90 100 80)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "ln ln-1",
    x: 62,
    y: 122,
    width: 76,
    height: 7,
    rx: 3.5,
    fill: "#d7e2ee"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "ln ln-2",
    x: 76,
    y: 136,
    width: 48,
    height: 6,
    rx: 3,
    fill: "#e6edf5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "badge"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 150,
    r: 18,
    fill: "#0f9d63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 150,
    r: 18,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "tick",
    d: "M140.8 150.5 L146 156 L155.6 145.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtActivate);
export default __webpack_public_path__ + "static/media/art-activate.60938245596be1282ed1e2e48c58665e.svg";
export { ForwardRef as ReactComponent };